export default {
  namespace: true,
  state: () => ({}),
  mutation: {},
  actions: {},
  getters: {},
  modules: {},
};
